const nuevoTurnoInitialState = {
  nuevoTurno: {
    familiar: null,
    seleccionMasSolicitado: null,
    videoAtencion: false,
    dtoBusqueda: null,
    turnoAsignado: null,
    filtroKinesio: { dias: null, horarios: null },
    fechaDesdeKinesio: null,
    osAlternativa: false,
  },
};
export default nuevoTurnoInitialState;
